import React from "react";
var __jsx = React.createElement;
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import { useTranslation } from "@i18n";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
import { useEffect } from "react";
import { trackEvents } from "@/common/events/events";
import { getAndClearWarrantyGtmData } from "@/pages/tracking/warranty-payment/warrantyGtmStorage";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { toOrderId } from "@/common/events/toOrderId";
var WarrantyPaymentSuccessPage = function WarrantyPaymentSuccessPage() {
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  useEffect(function () {
    var _gtmData$referral_loc, _gtmData$order_type, _gtmData$selected_war;
    var gtmData = getAndClearWarrantyGtmData();
    trackEvents("warranty_payment_success", {
      order_id: toOrderId(gtmData === null || gtmData === void 0 ? void 0 : gtmData.order_id),
      referral_location: (_gtmData$referral_loc = gtmData === null || gtmData === void 0 ? void 0 : gtmData.referral_location) !== null && _gtmData$referral_loc !== void 0 ? _gtmData$referral_loc : null,
      order_type: (_gtmData$order_type = gtmData === null || gtmData === void 0 ? void 0 : gtmData.order_type) !== null && _gtmData$order_type !== void 0 ? _gtmData$order_type : "cash",
      selected_warranty: (_gtmData$selected_war = gtmData === null || gtmData === void 0 ? void 0 : gtmData.selected_warranty) !== null && _gtmData$selected_war !== void 0 ? _gtmData$selected_war : null
    });
  }, []);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    disableLoader: true,
    headHideLinks: true,
    authenticationMsg: true,
    hideFooterWithoutAuthMsg: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: isWebView,
    mainClass: "flex flex-col"
  }, /*#__PURE__*/React.createElement(InfoScreen, {
    fullScreen: false,
    icon: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "80",
      height: "80",
      rx: "16",
      fill: "#E6F7EF"
    }), /*#__PURE__*/React.createElement("g", {
      opacity: "0.99"
    }, /*#__PURE__*/React.createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 40C8 22.3279 22.3279 8 40 8C57.6739 8 72 22.3279 72 40C72 57.6761 57.6741 72 40 72C22.3279 72 8 57.6741 8 40ZM14 39.9999C14 54.3598 25.64 65.9998 39.9999 65.9998C54.3598 65.9998 65.9998 54.3598 65.9998 39.9999C65.9998 25.64 54.3598 14 39.9999 14C25.64 14 14 25.64 14 39.9999Z",
      fill: "#00B362"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.6717 49.5438C35.2105 49.5438 34.7497 49.3699 34.3989 49.0191L26.5955 41.2655C25.892 40.5661 25.892 39.4329 26.5955 38.7339C27.2989 38.035 28.4394 38.035 29.1432 38.7339L35.6739 45.2233L50.0088 30.9803C50.7122 30.2813 51.8527 30.2813 52.5561 30.9803C53.2596 31.6792 53.2596 32.8124 52.5561 33.5114L36.9489 49.0191C36.5936 49.3699 36.1329 49.5438 35.6717 49.5438Z",
      fill: "#00B362",
      stroke: "#00B362",
      "stroke-width": "2.2"
    }))),
    title: tShort("warranty/payment_success_title"),
    text: tShort("warranty/payment_success_description"),
    primaryButton: {
      label: tShort("warranty/track_order"),
      onClick: function onClick() {
        webview.openScreen("tracking_order", {})["catch"](function () {
          navigateToHard("/tracking-landing");
        });
      }
    }
  }));
};
export default WarrantyPaymentSuccessPage;